export default __webpack_public_path__ + "images/facebook-1628e7eb420903c512ffd042f9948d21.svg";